/**
 * DownStream Report Main index file which is refered in reports Page
 */
import React, { useState, useContext, useEffect, useRef } from "react";

import moment from "moment";

import axios from "../../../../common/AxiosConfig";

import { AppContext } from "../../../../../RoutesWithAuth";

import { Typography} from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormGroup from "../../FormGroup";

import { RequestorMapping, v2UIRoutePath } from '../../../../common/commons';
import { REPORT_RIGHTS, isReportRightApplicable, mapReportValues } from '../reportRights';

import DownstreamBarGraph from "./DownstreamBarGraph";

import { Link, useLocation } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    root: {

    },
    formGroupWrapper: {
        width: '600px',
        '& .multiSelectedOptions': {
            width: '140px'
        }
    },
    customInputCls: {
        width: '140px',
    },

}));
function DownstreamChart(props) {
    const context = useContext(AppContext)
    const location = useLocation();
    const authToken = context.authToken.get
    const classes = useStyles();
    const today = moment();
    const formGroupRef = useRef();
    const oneYearAgo = moment().subtract(1, 'years').subtract(1, 'days');

        // Local UI states for date pickers (can be empty string to show cleared)
    const [uiFromDate, setUiFromDate] = useState(oneYearAgo.format("YYYY-MM-DD"));
    const [uiToDate, setUiToDate] = useState(today.format("YYYY-MM-DD"));

    //state for maintaining form related data
    const [formData, setFormData] = useState({
        from_date: oneYearAgo.format("YYYY-MM-DD"),  // default from_date = current date - 1 year
        to_date: today.format("YYYY-MM-DD"),
        requestor: ['All']
    });
    const [downstreamMetrics, setDownstreamMetrics] = useState([])

    useEffect(() => {
        // resetting the Form when there is change in the Location state.
        formGroupRef.current.resetFormToDefaults();
        setUiFromDate(oneYearAgo.format("YYYY-MM-DD"));
        setUiToDate(today.format("YYYY-MM-DD"));
        setFormData({
        from_date: oneYearAgo.format("YYYY-MM-DD"),  // default from_date = current date - 1 year
        to_date: today.format("YYYY-MM-DD"),
            requestor: ['All']
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.state?.fromredirection])

    useEffect(() => {
        if (authToken) {
            fetchData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, JSON.stringify(formData)])

    const fetchData = () => {
        let requestor = formData.requestor.join(', ')?.toLowerCase();
        if (requestor === "all") {
            requestor = "ALL"
        } else if(requestor === "") {
            return false
        }

        axios.get('/reports/aging', {
            params: {
                metric_age: "all",
                downstream_chart: true,
                ...formData,
                requestor
            },
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setDownstreamMetrics(
                res.data.old.reverse().map(system => {
                    const values = mapReportValues(system.data);
                    const rights = REPORT_RIGHTS.filter(right => isReportRightApplicable(right.key, formData.requestor));
                    const downstreamTotal = rights.reduce((sum, right) => sum + values[right.key], 0);

                    return {
                        name: system.name + ` (${downstreamTotal})`,
                        ...Object.fromEntries(rights.map(right => [right.abbr, values[right.key]])),
                    }
                })
            )

        }).catch(err => {
            console.log(err)
        })
    }

    return (

        <div className={`${classes.root}`}>
            <Typography variant="h6" className={'tabHeader'}>
                <Link color="primary" to={() => {
                    // Generating a Random Id and passing it as part of state 
                    // Every click on the Header will generate a unique Id
                    const autoId = Math.round(Math.random() * 1e5);
                    return {
                        pathname: v2UIRoutePath + "reports/downstreamreport",
                        state: { fromredirection: autoId }
                    }
                }}
                >
                    DOWNSTREAM REPORT
                </Link>
            </Typography>
            <FormGroup
                formWrapperClassName={classes.formGroupWrapper}
                ref={formGroupRef}
                fields={[{
                    type: 'date',
                    name: "from_date",
                    label: "From Date",
                    defaultOption: uiFromDate,
                    inputAdditionalProps: {
                        min: "2020-01-01",
                        max: today.format("YYYY-MM-DD")
                    }
                }, {
                    type: 'date',
                    name: "to_date",
                    label: "To Date",
                    defaultOption: uiToDate,
                    inputAdditionalProps: {
                        min: formData?.from_date || "2020-01-01",
                        max: today.format("YYYY-MM-DD")
                    }
                }, {
                    type: 'multiselect',
                    name: 'requestor',
                    label: 'Requestor',
                    isMulti: true,
                    customInputCls: classes.customInputCls,
                    options: ["All", ...Object.values(RequestorMapping)],
                    defaultOption: 'All',
                    size: 2
                }]}
                disableFormActions={true}
                customFormUpdates={(newFormData) => {
                     // Update UI states for dates to reflect clearing or selection
                    setUiFromDate(newFormData.from_date || '');
                    setUiToDate(newFormData.to_date || '');

                    // Update formData for API calls (keep null or empty if cleared)
                    setFormData({
                        from_date: newFormData.from_date || null,
                        to_date: newFormData.to_date || null,
                        requestor: newFormData.requestor
                    })
                }}
            />
            <div style={{ height: "570px" }}>
                <DownstreamBarGraph
                    data={downstreamMetrics}
                    requestor={formData.requestor}
                />
            </div>
        </div>
    );
}

export default React.memo(DownstreamChart);
